module.exports = __webpack_public_path__ + "static/img/jq-logo.5807353.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jq/jq-logo.png
// module id = EeQx
// module chunks = 1